import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-entity-display',
    templateUrl: './entity-display.component.html',
    styleUrls: ['./entity-display.component.less'],
    standalone: false
})
export class EntityDisplayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
